import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { IStep } from '../../../../shared/interfaces/step.interface';
import { UserRole } from '../../../../core/auth/enums/userRoles';

interface TimelineItem {
  name: string;
  value: string;
  status?: string; // will need to know the exact options (early, late, ...)
  timeDifference?: string;
}

@Component({
  selector: 'app-ride-timeline-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './ride-timeline-tooltip.component.html',
  styleUrl: './ride-timeline-tooltip.component.scss',
})
export class RideTimelineTooltipComponent {
  readonly data = input<{
    status: string; // will need to know the exact options (arrived, en route, ...)
    timeline: TimelineItem[];
  }>();
  isClient = localStorage.getItem('role')?.toLowerCase() == UserRole.Client;
  stop = input<IStep>();
}
